import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative flex flex-col flex-wrap gap-2 pb-3 sm:flex-row" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { ref, computed, ComputedRef } from 'vue';

import {
    CallModel,
    CallWordModel,
    CallParticipantType,
    CallPlayerGetters,
    CallPlayerMutations,
} from '@/types';

import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'CallWords',
  props: {
    call: {
        type: Object as () => CallModel,
        required: true,
    },
    participantType: {
        type: String as () => CallParticipantType,
        required: true,
    },
},
  setup(__props) {



const showHiddenWords = ref(false);
const transcripts = __props.call?.transcripts || [];

const callPlayerSearchQuery: ComputedRef<string> = computed(
    () => store.getters[CallPlayerGetters.SEARCH_QUERY],
);
const callPlayerSelectedWords: ComputedRef<string[]> = computed(() => {
    const selectedWordsMap = store.getters[CallPlayerGetters.SELECTED_WORDS];
    return Array.from(selectedWordsMap.get(__props.participantType) ?? []);
});

const words: ComputedRef<CallWordModel[]> = computed(() => {
    const wordMap: Map<string, CallWordModel> = new Map();

    transcripts
        .filter(({ participant }) => participant === __props.participantType)
        .forEach(({ words, registeredWords }) => {
            words.forEach((word) => {
                const existing = wordMap.get(word);
                if (existing) existing.counter += 1;
                else
                    wordMap.set(word, {
                        text: word,
                        counter: 1,
                        registered: registeredWords.includes(word),
                        selected: callPlayerSelectedWords.value.includes(word),
                        matched: word === callPlayerSearchQuery.value,
                    });
            });
        });

    return Array.from(wordMap.values()).sort((a, b) => {
        // Sort by registered
        if (a.registered !== b.registered) return a.registered ? -1 : 1;
        // Sort by counter
        if (a.counter !== b.counter) return b.counter - a.counter;
        // Sort by text
        return a.text.localeCompare(b.text);
    });
});

const filteredWords: ComputedRef<CallWordModel[]> = computed(() =>
    showHiddenWords.value ? words.value : words.value.slice(0, 10),
);

return (_ctx: any,_cache: any) => {
  const _component_UiBadge = _resolveComponent("UiBadge")!
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createBlock(_component_UiPanel, null, {
    default: _withCtx(() => [
      _createElementVNode("h3", {
        class: _normalizeClass(["mb-3 text-lg font-medium", 
                __props.participantType == _unref(CallParticipantType).Client ? 'text-purple-500' : 'text-blue-500'
            ])
      }, _toDisplayString(_ctx.$t('call.view.participant.' + __props.participantType.toLowerCase())), 3),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredWords.value, (word) => {
          return (_openBlock(), _createBlock(_component_UiBadge, {
            key: `${__props.participantType}-word-${word.text}`,
            class: "cursor-pointer rounded",
            variant: word.selected ? 'orange' : word.registered ? 'blue' : 'gray',
            onClick: ($event: any) => (
                    _unref(store).commit(_unref(CallPlayerMutations).TOGGLE_SELECTED_WORD, {
                        participant: __props.participantType,
                        word: word.text,
                    })
                )
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(word.text), 1)
            ]),
            number: _withCtx(() => [
              _createTextVNode(_toDisplayString(word.counter), 1)
            ]),
            _: 2
          }, 1032, ["variant", "onClick"]))
        }), 128)),
        (words.value.length > 10)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "absolute bottom-0 right-0 cursor-pointer text-sm text-orange-600 hover:text-orange-800",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showHiddenWords.value = !showHiddenWords.value))
            }, [
              (!showHiddenWords.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('core.actions.SeeMore')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('core.actions.SeeLess')), 1))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})